/**
 * iPIDiagram Application Configuration
 */

import type { DropdownOption, SectionConfig } from '../shared';

export const APP_NAME = 'iPIDiagram';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

// Load type options
export const LOAD_TYPES: DropdownOption[] = [
  { value: '0', label: 'Triangular Load' },
  { value: '1', label: 'Triangular Pulse Load' },
  { value: '2', label: 'Rectangular Load' }
];

/**
 * API Payload Type
 */
export interface APIPayload {
  title: string;
  length: string;
  tribWidth: string;
  hingeLength: string;
  totalWeight: string;
  klmFactor: string;
  Ru: string;
  Xe: string;
  loadType: string;
  Pa: string;
  Ia: string;
  ductilityLimit: string;
  rotationLimit: string;
}

/**
 * API Response Type
 */
export interface APIResponse {
  TA: number;
  K: number;
  Me: number;
  Tn: number;
  Ru: number;
  charts: {
    chart_qc?: { mime: string; base64: string };
  };
}

/**
 * Response Display Configuration
 */
export const RESPONSE_DISPLAY_CONFIG: SectionConfig<APIResponse>[] = [
  {
    title: 'Results',
    fields: [
      { key: 'TA', label: 'Tributary Area', getValue: data => `${data.TA.toFixed(2)} ft²` },
      { key: 'K', label: 'Stiffness', getValue: data => `${data.K.toFixed(2)} kips/in` },
      { key: 'Me', label: 'Effective Mass', getValue: data => `${data.Me.toFixed(3)} lbf-in/sec²` },
      { key: 'Tn', label: 'Natural Period', getValue: data => `${data.Tn.toFixed(2)} ms` },
      { key: 'Ru', label: 'Resistance', getValue: data => `${data.Ru.toFixed(2)} psi` }
    ]
  }
];
